
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bBy4d", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.7b109d10.js.map
